import { render, staticRenderFns } from "./AccidentHistoryEdit.vue?vue&type=template&id=6ce5419c&scoped=true&lang=pug&"
import script from "./scripts/AccidentHistoryEdit.js?vue&type=script&lang=js&"
export * from "./scripts/AccidentHistoryEdit.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce5419c",
  null
  
)

export default component.exports